import { useState } from "react";
import { createUseStyles } from "react-jss";
import Addicon from "@mui/icons-material/Add";
import { useSnackbar } from "react-simple-snackbar";
import useAuth from "$hooks/useAuth";
import { Button, Popin } from "$components";
import { addProduct } from "$api/productApi";
import ProductForm from "$containers/Products/ProductForm";
import { snackbarErrorOptions } from "$utils/SnackbarOptions";

const useStyles = createUseStyles(() => ({
  CreateEdbPage_Popin: {
    "& .MuiDrawer-paper": {
      width: "786px !important",
      overflowY: "unset !important",
    },
  },
}));

type Props = {
  companyId: string;
  addToCart: any;
};

function AddProductButton({ companyId, addToCart }: Props) {
  // Catalog
  const [isPopinAddProductOpen, setIsPopinAddProductOpen] =
    useState<boolean>(false);

  const [openSnackbarError] = useSnackbar(snackbarErrorOptions);

  const { token } = useAuth();

  // step 2 functions
  const onSubmit = async (data: any) => {
    const ERROR_MSG =
      "Un produit hors catalogue existe déjà avec cette référence. Veuillez annuler l'ajout ou modifier la référence";
    try {
      const result: any = await addProduct(token, {
        ...data,
        company: companyId,
        isReferenced: false,
      });
      if (result?.data?.data) {
        addToCart(
          result?.data.data._id,
          data.quantity,
          true,
          result?.data?.data
        ); // éléments qu'on ajoute dans le cas des produtis hors catalogue
        setIsPopinAddProductOpen(false);
      } else if (result?.error) {
        openSnackbarError(ERROR_MSG);
      }
    } catch (error) {
      openSnackbarError(ERROR_MSG);
    }
  };

  const classes = useStyles();

  return (
    <>
      <Button
        color="secondary"
        onClick={() => {
          setIsPopinAddProductOpen(true);
        }}
      >
        <Addicon />
        Ajout produit hors catalogue
      </Button>
      <Popin
        className={classes.CreateEdbPage_Popin}
        openPopin={isPopinAddProductOpen}
        toggleDrawer={() => setIsPopinAddProductOpen(false)}
      >
        <ProductForm
          onSubmit={onSubmit}
          onReset={() => setIsPopinAddProductOpen(false)}
          company={{ _id: companyId }}
          isReferenced={false}
        />
      </Popin>
    </>
  );
}

export default AddProductButton;
